import React, { Component } from "react";
import Button from "@material-ui/core/Button";

import "./Namecard2.css";

export default class Namecard2 extends Component {
  render() {
    return (
      <div>
        <figure class="snip1559">
          {/* <div class="profile-image"> */}
          {/* <img
              src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/331810/profile-sample2.jpg"
              alt="profile-sample2"
            /> */}
          {/* </div> */}
          <figcaption>
            {/* Fluent in */}
            <h5>
              <b>Fluent in:</b> <br />
              English, Spanish
            </h5>
            <br />
            {/* Interested in learning */}
            <h5>
              <b>Interested in learning:</b> <br />
              French, Italian
            </h5>
            <br />
            {/* Accent from */}
            <h5>
              <b>Accent from:</b> <br />
              Spain
            </h5>
            <br />
            <p>Available to chat in the weekends to study new languages.</p>
            <Button
              href="https://calling-app-aws.herokuapp.com/"
              color="primary"
              variant="raised"
            >
              Talk to them
            </Button>
          </figcaption>
        </figure>
      </div>
    );
  }
}
